import { Graphic2DDynamicVIBuffer } from "../Scene2DSpecial/Graphic2DDynamicVIBuffer";
export function drawTrianglesBatched(runner, tex, x, y, vertices, uvs, indices, matrix, alpha, blendMode, colorNum, colors, uvRange) {
    const vertexCount = vertices.length / 2;
    const maxBatchVertices = Graphic2DDynamicVIBuffer.MAX_VERTEX;
    if (vertexCount <= maxBatchVertices) {
        runner.drawTriangles(tex, x, y, vertices, uvs, indices, matrix, alpha, blendMode, colorNum, colors, uvRange);
        return;
    }
    const triangleCount = indices.length / 3;
    let batchStart = 0;
    while (batchStart < triangleCount) {
        const remap = new Map();
        let newVertCount = 0;
        let batchEnd = batchStart;
        while (batchEnd < triangleCount) {
            let needed = 0;
            for (let j = 0; j < 3; j++) {
                if (!remap.has(indices[batchEnd * 3 + j]))
                    needed++;
            }
            if (newVertCount + needed > maxBatchVertices)
                break;
            for (let j = 0; j < 3; j++) {
                const idx = indices[batchEnd * 3 + j];
                if (!remap.has(idx)) {
                    remap.set(idx, newVertCount++);
                }
            }
            batchEnd++;
        }
        const batchVerts = new Float32Array(newVertCount * 2);
        const batchUVs = new Float32Array(newVertCount * 2);
        const batchColors = colors ? new Float32Array(newVertCount * 4) : null;
        const indexCount = (batchEnd - batchStart) * 3;
        const batchIndices = new Uint16Array(indexCount);
        remap.forEach((newIdx, oldIdx) => {
            batchVerts[newIdx * 2] = vertices[oldIdx * 2];
            batchVerts[newIdx * 2 + 1] = vertices[oldIdx * 2 + 1];
            batchUVs[newIdx * 2] = uvs[oldIdx * 2];
            batchUVs[newIdx * 2 + 1] = uvs[oldIdx * 2 + 1];
            if (colors && batchColors) {
                batchColors[newIdx * 4] = colors[oldIdx * 4];
                batchColors[newIdx * 4 + 1] = colors[oldIdx * 4 + 1];
                batchColors[newIdx * 4 + 2] = colors[oldIdx * 4 + 2];
                batchColors[newIdx * 4 + 3] = colors[oldIdx * 4 + 3];
            }
        });
        for (let t = batchStart; t < batchEnd; t++) {
            const bi = (t - batchStart) * 3;
            batchIndices[bi] = remap.get(indices[t * 3]);
            batchIndices[bi + 1] = remap.get(indices[t * 3 + 1]);
            batchIndices[bi + 2] = remap.get(indices[t * 3 + 2]);
        }
        runner.drawTriangles(tex, x, y, batchVerts, batchUVs, batchIndices, matrix, alpha, blendMode, colorNum, batchColors, uvRange);
        batchStart = batchEnd;
    }
}
